import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductVariantPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductVariantPriceRange.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductVariantFullInfoQueryVariables = Types.Exact<{
  pk?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  productPk?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  attrs?: Types.InputMaybe<Array<Types.VariantAttrsInput> | Types.VariantAttrsInput>;
  cartType: Types.CartTypeEnum;
}>;


export type ProductVariantFullInfoQuery = { productVariant: { id: string, pk: number, sku: string, weightOverride: number | null, lengthOverride: number | null, shippingRequired: boolean, widthOverride: number | null, heightOverride: number | null, isSupply: boolean, isInCart: boolean, cartQuantity: number, upc: string, ean: string, isbn: string, stockQuantity: number, outOfStockStatus: Types.OutOfStockStatusEnum, itemData: any | null, wholesaleDescription: string, isCustomizable: boolean, hasDefaultKit: boolean, stockStatus: Types.OutOfStockStatusEnum | null, defaultKitPrice: { currency: string, gross: number } | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, wholesalePrice: { currency: string, undiscount: number, discount: number }, allImages: Array<{ id: string, alt: string, thumbnailUrl: string | null, width: number, height: number, url: string }> } | null };


export const ProductVariantFullInfoDocument = gql`
    query ProductVariantFullInfo($pk: Int, $productPk: Int, $attrs: [VariantAttrsInput!], $cartType: CartTypeEnum!) {
  productVariant(pk: $pk, productPk: $productPk, attrs: $attrs) {
    id
    pk
    sku
    weightOverride
    lengthOverride
    shippingRequired
    widthOverride
    heightOverride
    isSupply
    isInCart(cartType: $cartType)
    cartQuantity(cartType: $cartType)
    upc
    ean
    isbn
    stockQuantity
    outOfStockStatus
    itemData
    wholesaleDescription
    isCustomizable
    hasDefaultKit
    defaultKitPrice {
      currency
      gross
    }
    stockStatus
    priceRange {
      ...ProductVariantPriceRangeFragment
    }
    wholesalePrice {
      currency
      undiscount
      discount
    }
    allImages {
      id
      alt
      url: image
      thumbnailUrl(size: "1000x0", method: CROP_WEBP)
      width
      height
    }
  }
}
    ${ProductVariantPriceRangeFragmentDoc}`;

/**
 * __useProductVariantFullInfoQuery__
 *
 * To run a query within a React component, call `useProductVariantFullInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantFullInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantFullInfoQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *      productPk: // value for 'productPk'
 *      attrs: // value for 'attrs'
 *      cartType: // value for 'cartType'
 *   },
 * });
 */
export function useProductVariantFullInfoQuery(baseOptions: Apollo.QueryHookOptions<ProductVariantFullInfoQuery, ProductVariantFullInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductVariantFullInfoQuery, ProductVariantFullInfoQueryVariables>(ProductVariantFullInfoDocument, options);
      }
export function useProductVariantFullInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductVariantFullInfoQuery, ProductVariantFullInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductVariantFullInfoQuery, ProductVariantFullInfoQueryVariables>(ProductVariantFullInfoDocument, options);
        }
export type ProductVariantFullInfoQueryHookResult = ReturnType<typeof useProductVariantFullInfoQuery>;
export type ProductVariantFullInfoLazyQueryHookResult = ReturnType<typeof useProductVariantFullInfoLazyQuery>;
export type ProductVariantFullInfoQueryResult = Apollo.QueryResult<ProductVariantFullInfoQuery, ProductVariantFullInfoQueryVariables>;
export function refetchProductVariantFullInfoQuery(variables: ProductVariantFullInfoQueryVariables) {
      return { query: ProductVariantFullInfoDocument, variables: variables }
    }